export default "__VITE_ASSET__429d9865__"